import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  CreateFacultyAPI,
  CreateFacultyFieldsAPI,
  DeleteFacultyAPI,
  DeleteFacultyFieldsAPI,
  FacultyListByDegreeAPI,
  ListActiveFacultiesFieldsAPI,
  ListFacultiesAPI,
  ListFacultyFieldsAPI,
  UpdateFacultyAPI,
  UpdateFacultyFieldsAPI,
} from "./faculty.api";

export const facultyKeys = {
  all: ["faculties"],
  activeFields: () => [...facultyKeys.all, "active-fields"],
  byDegree: () => [...facultyKeys.all, "by-degree"],
  lists: () => [...facultyKeys.all, "list"],
  list: (params) => [...facultyKeys.lists(), params],
  fieldLists: () => [...facultyKeys.all, "fields", "list"],
  fieldList: (params) => [...facultyKeys.fieldLists(), params],
};

export const useActiveFacultiesFieldsQuery = () =>
  useQuery({
    queryKey: facultyKeys.activeFields(),
    queryFn: ListActiveFacultiesFieldsAPI,
  });

export const useFacultyListByDegreeQuery = () =>
  useQuery({
    queryKey: facultyKeys.byDegree(),
    queryFn: FacultyListByDegreeAPI,
  });

export const useFacultiesListQuery = (params) =>
  useQuery({
    queryKey: facultyKeys.list(params),
    queryFn: () => ListFacultiesAPI(params),
  });

export const useFacultyFieldsListQuery = (params) =>
  useQuery({
    queryKey: facultyKeys.fieldList(params),
    queryFn: () => ListFacultyFieldsAPI(params),
    enabled: Boolean(params?.faculty),
  });

export const useCreateFacultyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: CreateFacultyAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyKeys.all });
    },
  });
};

export const useUpdateFacultyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateFacultyAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyKeys.all });
    },
  });
};

export const useDeleteFacultyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DeleteFacultyAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyKeys.all });
      queryClient.invalidateQueries({ queryKey: ["faculty-groups"] });
    },
  });
};

export const useCreateFacultyFieldsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: CreateFacultyFieldsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyKeys.all });
      queryClient.invalidateQueries({ queryKey: ["faculty-groups"] });
    },
  });
};

export const useUpdateFacultyFieldsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateFacultyFieldsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyKeys.all });
      queryClient.invalidateQueries({ queryKey: ["faculty-groups"] });
    },
  });
};

export const useDeleteFacultyFieldsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DeleteFacultyFieldsAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: facultyKeys.all });
      queryClient.invalidateQueries({ queryKey: ["faculty-groups"] });
    },
  });
};
